import {isEmpty} from 'lodash'
export function getPublicationColumns() {
    let columns = JSON.parse(localStorage.getItem('publicationColumns'))
    if (!isEmpty(columns)) {
        return columns
    }
    return ['checkbox','_id', 'name', 'publisher', 'city', 'country',  'language', 'url', 'article_count', 'author_count', 'settings']
 }
 
 export function getPublicationTableOptions() {
    return {
        filterByColumn: false,
        perPage:10,
        pagination: { show: false},
        filterable: false,
        headings: {
            name: 'Publication Name',
            publisher: 'Publisher',
            city : 'City',
            country: 'Country',
            author_count: 'Author Count',
            article_count: 'Article Count',
            _id: 'GUID',
            language: 'Language',
            url: 'URL'
          },
          sortable: ['no'],
          sortIcon: { base: 'as-nova', up: 'nova-tablesortinga-z', down: 'nova-tablesortingz-a', is: 'nova-tablesorting' },
    }
 }
 export function getPublicationTableSettingsOptions() {
    return [
           {key: 'checkbox', value: ('Checkbox') },
           {key: '_id', value: ('GUID')},
           {key: 'name', value: ('Name')},
           {key: 'publisher', value: ('Publisher')},
           {key: 'city', value: ('City')},
           {key: 'country', value: ('Country')},
           {key: 'language', value: ('Language')},
           {key: 'url', value: ('URL')},
           {key: 'author_count', value: ('Author Count')},
           {key: 'article_count', value: ('Article Count')},
           {key: 'settings', value: ('Settings')},
    ]
    
}